export const isGpxFile = (name) => /\.gpx$/i.test(name ?? '')

const positionsFrom = (points) => Array.from(points)
  .map(p => [parseFloat(p.getAttribute('lon')), parseFloat(p.getAttribute('lat'))])
  .filter(([lon, lat]) => Number.isFinite(lon) && Number.isFinite(lat))

const nameOf = (node) => node.getElementsByTagName('name')[0]?.textContent?.trim() ?? ''

export function gpxToGeojson (xmlText) {
  const doc = new DOMParser().parseFromString(xmlText, 'application/xml')
  if (doc.getElementsByTagName('parsererror').length > 0) return null

  const features = []
  const addLine = (coordinates, name) => {
    if (coordinates.length > 1) {
      features.push({ type: 'Feature', geometry: { type: 'LineString', coordinates }, properties: { name } })
    }
  }

  for (const trk of Array.from(doc.getElementsByTagName('trk'))) {
    for (const seg of Array.from(trk.getElementsByTagName('trkseg'))) {
      addLine(positionsFrom(seg.getElementsByTagName('trkpt')), nameOf(trk))
    }
  }
  for (const rte of Array.from(doc.getElementsByTagName('rte'))) {
    addLine(positionsFrom(rte.getElementsByTagName('rtept')), nameOf(rte))
  }
  for (const wpt of Array.from(doc.getElementsByTagName('wpt'))) {
    const [position] = positionsFrom([wpt])
    if (position) {
      features.push({ type: 'Feature', geometry: { type: 'Point', coordinates: position }, properties: { name: nameOf(wpt) } })
    }
  }

  return { type: 'FeatureCollection', features }
}
